// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"782":"21443c38","810":"5567108a","1639":"fcef6ca2","3641":"e9c6c033","5657":"5567108a","8714":"5567108a"}[chunkId] + ".chunk.css";
};